// Resend the activation email for an admin still in the `invited` /
// `expired` state. Lists refresh (so the row's invitation chip updates)
// and the summary refreshes (pending-invites count).

import { useMutation, useQueryClient } from '@tanstack/vue-query'

import { resendInvite } from '../adminsEndpoints'
import { adminsQueryKeys } from '../adminsQueryKeys'

export function useResendInviteMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => resendInvite(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: adminsQueryKeys.lists() })
    },
  })
}
